export default () => ({
  staffList: [],
});
